import React from 'react';
import { Card, Space, Typography, Select, Alert } from 'antd';
import { DatePicker } from 'antd';
import PointSelector from '../../Shared/PointSelector';
import dayjs from 'dayjs';



const { Title, Text } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;

const ParameterSelection = ({
  exploitationPoints,
  selectedPoint,
  dateRange,
  dateRangeOptions,
  selectedDateRange,
  onPointChange,
  onDateRangeChange,
  onDateRangeOptionChange,
  selectedValve
}) => {
  return (
    <Card className="mb-6 p-4">
      <Title level={4} className="mb-4">Paramètres de sélection</Title>
      <Space direction="vertical" size="middle" className="w-full">
        <div className='flex gap-8 flex-col md:flex-row'>
          <div>
            <Text strong className="block mb-2">Sélectionnez un point d'exploitation :</Text>
            <PointSelector
              exploitationPoints={exploitationPoints}
              selectedPoint={selectedPoint}
              onPointChange={onPointChange}
            />
          </div>
          {selectedPoint && (
            <div>
              <Text strong className="block mb-2">Informations sur le point sélectionné :</Text>
              <Text>
                <strong>Vanne associée : </strong>
                <span className='text-indigo-600 text-lg font-bold'>{selectedValve.valve_name || 'N/A'}</span>
              </Text>
            </div>
          )}
        </div>
        <div className="flex flex-col sm:flex-row sm:items-center space-y-2 sm:space-y-0 sm:space-x-4">
          <Text strong>Sélectionnez la période:</Text>
          <RangePicker
            className="w-full sm:w-auto"
            onChange={onDateRangeChange}
            value={dateRange}
            disabledDate={(current) => current && (current > dayjs())}
            presets={[
              { label: 'Aujourd\'hui', text: 'Aujourd\'hui', value: [dayjs().startOf('day'), dayjs()] },
              { label: 'La semaine dernière', text: 'La semaine dernière', value: [dayjs().subtract(1, 'week'), dayjs()] },
              { label: 'Ce mois-ci', text: 'Ce mois-ci', value: [dayjs().startOf('month'), dayjs()] },
              { label: 'Le mois dernier', text: 'Le mois dernier', value: [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')] }
            ]}

          />
        </div>
        {dateRangeOptions.length > 0 && (
          <div className="flex flex-col sm:flex-row sm:items-center space-y-2 sm:space-y-0 sm:space-x-4">
            <Text strong>Plage de dates pour les coordonnées :</Text>
            <Select
              style={{ width: 300 }}
              value={selectedDateRange}
              onChange={onDateRangeOptionChange}
            >
              {dateRangeOptions.map((option, index) => (
                <Option key={index} value={option.value}>
                  {option.label}
                </Option>
              ))}
            </Select>
          </div>
        )}
        {dateRangeOptions.length === 0 && dateRange && dateRange.length === 2 && (
          <Alert
            message="Information"
            description="Aucun changement de coordonnées n'a été enregistré pour ce point durant la période sélectionnée. Les données seront affichées pour toute la période."
            type="info"
          />
        )}
      </Space>
    </Card>
  );
};

export default ParameterSelection;